import api from 'config/api.config';
import { getErrorMessage } from 'utils/errors';

export const globalInstagramSearch = async (query: string, type: string = 'user', social_media_account_id: string) => {
  try {
    const response = await api.post(
      `/api/instagram/search?query=${encodeURIComponent(query)}&type=${encodeURIComponent(type)}`,
      { social_media_account_id }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch Instagram search results'));
  }
};

export default globalInstagramSearch;
